module.exports = __webpack_public_path__ + "static/instagram-cd102e18e2ac0c20b8c614f64a249dff.jpg";